import base from '@/__vue2stone/service/api/v1/__base';
import preUrl from '@/service/app/processor';
import store from '@/store';
import wsBase from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async index({ params }) {
    return base.index({
      modelName: 'contractor_customed_type',
      preUrl: preUrl.getFactoryPreUrl(),
      params: params,
    });
  },
  async create(factoryId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await wsBase.create({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'contractor',
      data: _data,
    });
    return res;
  },
  async update(typeId, data) {
    const currentFactory = store.state.app.factory;
    const _data = {
      factory: currentFactory.id,
      ...data,
    };
    const res = await wsBase.update({
      url: `factory/${currentFactory.id}/contractor_customed_type/${typeId}`,
      data: _data,
    });
    return res;
  },
  async show(typeId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await wsBase.show({
      url: `factory/${currentFactory.id}/contractor_customed_type/${typeId}`,
      params: _params,
    });
    return res;
  },
  async delete(typeId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await wsBase.delete({
      url: `factory/${currentFactory.id}/contractor_customed_type/${typeId}`,
      params: _params,
    });
    return res;
  },
  createUrl() {
    const currentFactoryId = store.state.app.factory.id;
    return `/factory/${currentFactoryId}/contractor_customed_type`
  }
};
